import { finalize } from 'rxjs/operators';

import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GMapsService } from '@app/views/pages/smartrouting/service/gmaps.service';
import { GMarker } from '@app/views/pages/smartrouting/models/gmaps/gmarker.model';

@Component({
	selector: 'kt-gviewer',
	templateUrl: './gviewer.component.html',
	styleUrls: ['./gviewer.component.scss']
})
export class GViewerComponent implements  AfterViewInit {

	@ViewChild('map', { static: false }) mapElement: any;


	constructor(
		private route: ActivatedRoute,
		private gmapService: GMapsService

	) {
	}
	ngAfterViewInit(): void {



		this.route.queryParamMap
			.subscribe(res => {

				let lat = res.get("lat")
				let lng = res.get("lng")
				let zoom = res.get("zoom")

				let zoomLevel = zoom ? +zoom : 15;
				
				this.gmapService.initMap(this.mapElement.nativeElement, zoomLevel);


				let marker = new GMarker();
				marker.position = { lat: +lat, lng: +lng }
				marker.animation = google.maps.Animation.DROP

				this.gmapService.MarkerOperation.addMarker(marker, new google.maps.LatLngBounds());

			});

	}

	


}
